(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('PvlogDialogController', PvlogDialogController);

    PvlogDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Pvlog'];

    function PvlogDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Pvlog) {
        var vm = this;

        vm.pvlog = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.pvlog.id !== null) {
                Pvlog.update(vm.pvlog, onSaveSuccess, onSaveError);
            } else {
                Pvlog.save(vm.pvlog, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('mVtasWebApp:pvlogUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.fecha = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
